import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LandingPage from "@/pages/LandingPage";
import InventoryPage from "@/pages/InventoryPage";
import RequestPage from "@/pages/RequestPage";
import RequestStatusPage from "@/pages/RequestStatusPage";
import ForkliftDetailPage from "@/pages/ForkliftDetailPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminRequestDetail from "@/pages/admin/AdminRequestDetail";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import LandingPageLP from "@/pages/LandingPageLP";
import SharedMatchesPage from "@/pages/SharedMatchesPage";
import CRMDashboard from "@/pages/admin/CRMDashboard";
import CRMClients from "@/pages/admin/CRMClients";
import CRMPipeline from "@/pages/admin/CRMPipeline";
import CRMAppointments from "@/pages/admin/CRMAppointments";
import AutomationPage from "@/pages/admin/AutomationPage";
import TasksPage from "@/pages/admin/TasksPage";
import CRMGuide from "@/pages/admin/CRMGuide";
import CRMClientDetail from "@/pages/admin/CRMClientDetail";
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Landing Page - standalone, no header/footer */}
      <Route path="/lp" element={<LandingPageLP />} />

      {/* Public share link (no auth, no header/footer) */}
      <Route path="/share/:token" element={<SharedMatchesPage />} />

      {/* Public customer-facing routes */}
      <Route
        path="/"
        element={
          <>
            <Header />
            <LandingPage />
            <Footer />
          </>
        }
      />
      <Route
        path="/inventory"
        element={
          <>
            <Header />
            <InventoryPage />
            <Footer />
          </>
        }
      />
      <Route
        path="/inventory/:id"
        element={
          <>
            <Header />
            <ForkliftDetailPage />
            <Footer />
          </>
        }
      />
      <Route
        path="/request"
        element={
          <>
            <Header />
            <RequestPage />
            <Footer />
          </>
        }
      />
      <Route
        path="/check-request"
        element={
          <>
            <Header />
            <RequestStatusPage />
            <Footer />
          </>
        }
      />

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="inventory" element={<AdminInventory />} />
        <Route path="requests" element={<AdminRequests />} />
        <Route path="requests/:requestId" element={<AdminRequestDetail />} />
        <Route path="notifications" element={<AdminNotifications />} />
        <Route path="crm" element={<CRMDashboard />} />
        <Route path="crm/clients" element={<CRMClients />} />
        <Route path="crm/clients/:clientId" element={<CRMClientDetail />} />
        <Route path="crm/pipeline" element={<CRMPipeline />} />
        <Route path="crm/appointments" element={<CRMAppointments />} />
        <Route path="crm/guide" element={<CRMGuide />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="automation" element={<AutomationPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
